import React from 'react';
import classnames from 'classnames';
import FeedbackButton from 'Shared/Button/Feedback';
import { timeout } from 'Shared/timeout';
import * as styles from './base.scss';
export default ({ text, disabled, onClick, onClose, customMarking, className }) => {
    const onClickHandler = (e, activate) => {
        if (disabled) {
            return;
        }
        let maybePromise = onClick(e);
        if (maybePromise instanceof Promise) {
            e.stopPropagation();
            activate(maybePromise).then(() => timeout(1000).then(() => onClose && onClose()));
        }
    };
    return (React.createElement("div", { className: className },
        React.createElement(FeedbackButton, { className: classnames(styles.item, styles.button, { [styles.disabled]: disabled }), appearance: "bare", onClickWithFeedback: onClickHandler },
            text,
            " ",
            !!customMarking && (React.createElement("span", null, customMarking)))));
};
